import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useResizable from '../hooks/useResizable';
import css from './SidePanel.css';

const SidePanel = ({
    storageKey,
    minPercent = 0,
    maxPercent = 85,
    defaultPercent,
    collapseBelowPercent = 0,
    isExpanded = false,
    onClose,
    className,
    children,
}) => {
    const { widthPercent, elementRef, handleMouseDown, isDragging } = useResizable({
        minPercent,
        maxPercent,
        defaultPercent,
        storageKey,
        collapseBelowPercent,
        onCollapse: onClose,
    });

    return (
        <div
            ref={elementRef}
            className={classNames(css.panel, className, {
                [css.expanded]: isExpanded,
                [css.dragging]: isDragging,
            })}
            style={isExpanded ? undefined : { width: `${widthPercent}%` }}
        >
            {!isExpanded && <div className={css.resizeHandle} onMouseDown={handleMouseDown} />}
            {children}
        </div>
    );
};

SidePanel.propTypes = {
    storageKey: PropTypes.string.isRequired,
    minPercent: PropTypes.number,
    maxPercent: PropTypes.number,
    defaultPercent: PropTypes.number.isRequired,
    // Releasing the handle at or below this width calls onClose instead of
    // leaving an unusable sliver. Zero disables it.
    collapseBelowPercent: PropTypes.number,
    isExpanded: PropTypes.bool,
    onClose: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.node,
};

export default SidePanel;
